(() => {
  'use strict';
  if (window.rlProductPolicyDialogsReady) return;
  window.rlProductPolicyDialogsReady = true;

  const selector = 'dialog[data-rl-policy-dialog]';
  const openers = new WeakMap();
  const hasOpenDialog = () => document.querySelector(`${selector}[open]`);
  const syncScrollLock = () => {
    document.documentElement.classList.toggle('rl-policy-modal-open', Boolean(hasOpenDialog()));
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-rl-policy-open]');
    if (trigger) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(trigger.dataset.rlPolicyOpen);
      // Keep ordinary link navigation when dialogs or the policy body are unavailable.
      if (!dialog?.matches(selector) || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      const previous = hasOpenDialog();
      if (previous) previous.close();
      openers.set(dialog, trigger);
      dialog.showModal();
      syncScrollLock();
      const initialFocus = dialog.querySelector('[data-rl-policy-initial-focus]');
      initialFocus?.focus({ preventScroll: true });
      dialog.querySelector('.rl-policy-dialog__body')?.scrollTo(0, 0);
      return;
    }

    const closeButton = event.target.closest('[data-rl-policy-close]');
    const dialog = event.target.closest(selector);
    if (!dialog?.open) return;
    if (closeButton) {
      dialog.close();
      return;
    }
    // A click on the backdrop is retargeted to the native dialog element.
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });

  // Wrap Tab explicitly, including when initial focus is on the legal heading.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const dialog = hasOpenDialog();
    if (!dialog) return;
    const focusable = Array.from(dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (!first) {
      event.preventDefault();
      dialog.querySelector('[data-rl-policy-initial-focus]')?.focus();
    } else if (!focusable.includes(active) || (event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  });

  // Native showModal provides top-layer isolation; cancel is Escape.
  document.addEventListener('cancel', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(selector)) return;
    event.preventDefault();
    event.target.close();
  }, true);

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(selector)) return;
    syncScrollLock();
    const opener = openers.get(event.target);
    if (!hasOpenDialog() && opener?.isConnected) opener.focus({ preventScroll: true });
    openers.delete(event.target);
  }, true);

  // The Theme Editor can replace a section while its modal is open.
  document.addEventListener('shopify:section:unload', () => {
    requestAnimationFrame(syncScrollLock);
  });
})();
